var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MUIMenuItem from '@material-ui/core/MenuItem';
import useStyles from './SelectFieldItem.styles';
export const SeletFieldItem = (_a) => {
    var { children, thumbnailUrl } = _a, rest = __rest(_a, ["children", "thumbnailUrl"]);
    const classes = useStyles();
    return (_jsxs(MUIMenuItem, Object.assign({}, rest, { children: [thumbnailUrl && _jsx("img", { className: classes.thumbnail, src: thumbnailUrl }), _jsx("span", { children: children })] })));
};
export default SeletFieldItem;
//# sourceMappingURL=SelectFieldItem.js.map